import GetData from "@/utils/request.js"

const {
  $get,
  $post
} = new GetData();

export const getJwt = (mobile) => {
  return $get(`/h5/account/jwt/${mobile}`)
}

export const login = (data) => {
  location.href = '/h5/wx/login?app=gxxt&reURL=' + data
}
// 验证登陆票据
export const ticket = (data) => {
  return $get('/h5/wx/bind/ticket');
}

export const getWxConfig = (data) => {
  return $get('/h5/wx/js_api_conf', data);
}

//验证码
export const code = (data) => {
  return $get('/h5/user/sms/code/login/' + data);
}
//绑定手机号  /h5/wx/bind/bind
export const bind = (data) => {
  return $get('/h5/wx/bind/bind?mobile=' + data.mobile + '&code=' + data.code);
}

//判断是否登录
export const userLoginInfo = () => {
  return $post('/h5/account/userLoginInfo');
}

//验证码 变更绑定，绑定新手机短信(新)
export const getCode = (mobile) => {
  return $post('/h5/user/sms/code/mobileh5/bind/' + mobile);
}

//变更绑定，验证绑定新手机号(新)
export const verifyMobile = (code,mobile) => {
  return $post('/h5/account/mobileh5/verify/' + code+'/'+mobile);
}
//变更绑定，把手机账号合并到微信账号(新)
export const mergeUserInfoNew = (code,mobile) => {
  return $post('/h5/account/mergeUserInfoNew/' + code+'/'+mobile);
}
// 退出登录
export const logout = (data) => {
  return $get('/h5/account/logout');
}

export default {
  login,
  getWxConfig,
  ticket,
  code,
  bind,
  userLoginInfo,
  getJwt,
  getCode,
  logout,
  verifyMobile,
  mergeUserInfoNew
}
